import { Routes } from '@angular/router';
import { EditFormeComponent } from './edit-forme/edit-forme.component';
import { ListeFormesComponent } from './liste-formes/liste-formes.component';

export const FORMES_ROUTES_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP']
};

export const FORMES_ROUTES: Routes = [
    { path: '', component: ListeFormesComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id', component: EditFormeComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new', component: EditFormeComponent, data: { roles: ['ORGANISME'] } }
];
